import { SeriesMarkerShape } from 'lightweight-charts'
import {
  COLOR_GREEN_DARK,
  COLOR_BLUE_LIGHT,
  COLOR_NEON_MAGENTA,
  COLOR_PINK_DARK,
  COLOR_YELLOW
} from 'shared/constants'
import { AnnotationLabel, AnnotationType } from '../types'

export function getAnnotationColorByKey(key: AnnotationType) {
  const colors: Record<AnnotationType, string> = {
    entryPoint: COLOR_BLUE_LIGHT,
    takeProfit: COLOR_GREEN_DARK,
    stopLoss: COLOR_PINK_DARK,
    bullsEyePredict: COLOR_YELLOW,
    bullsEyeGuess: COLOR_NEON_MAGENTA,
    upDownPredict: COLOR_BLUE_LIGHT,
    ownPredict: COLOR_GREEN_DARK,
    opponentPredict: COLOR_PINK_DARK,
    '▶️ start game': COLOR_BLUE_LIGHT,
    '⏹️ end game': COLOR_PINK_DARK,
    '⏸️ stop predicts': COLOR_YELLOW,
    oneVsOneStart: COLOR_BLUE_LIGHT,
    oneVsOneEnd: COLOR_PINK_DARK,
    oneVsOneEndVertical: COLOR_PINK_DARK
  }

  return colors?.[key] || 'white'
}

export function getAnnotationNameByKey(key: AnnotationType) {
  const colors: Record<AnnotationType, AnnotationLabel> = {
    entryPoint: 'EP',
    stopLoss: 'SL',
    takeProfit: 'TP',
    bullsEyePredict: '🎯',
    bullsEyeGuess: 'YOUR GUESS',
    upDownPredict: '↕️',
    ownPredict: '🎯 OWN',
    opponentPredict: '🎯 OPPONENT',
    '▶️ start game': '▶️',
    '⏹️ end game': '⏹️',
    '⏸️ stop predicts': '⏸️',
    oneVsOneStart: '▶️',
    oneVsOneEnd: '⏹️',
    oneVsOneEndVertical: '⏹️'
  }

  return colors?.[key] || 'unknown'
}

export function getMarkerShapeByKey(
  key: string
): import('lightweight-charts').SeriesMarkerShape {
  const shapes: Record<string, SeriesMarkerShape> = {
    start: 'circle',
    stop: 'square'
  }

  return shapes?.[key] || 'arrowUp'
}

const NEON_LABEL_TEXT_COLOR = '#0d0c1a'

/**
 * Extra price-line label styling for specific annotation keys.
 * Returns an empty object for every legacy key so other modes stay pixel-identical.
 */
export function getAnnotationLabelStyleByKey(key: AnnotationType) {
  if (key === 'bullsEyeGuess') {
    return {
      axisLabelVisible: true,
      axisLabelColor: COLOR_NEON_MAGENTA,
      axisLabelTextColor: NEON_LABEL_TEXT_COLOR,
      lineWidth: 1 as const
    }
  }

  return {}
}
